import { useState, useEffect } from "react";
import { set as localDbSet } from "idb-keyval";
import { Hub } from "aws-amplify";
import { deviceImages } from "helpers/deviceImages";
import ImageOutbox from "helpers/imageOutbox";
import { getCurrentSession } from "helpers/apiHelpers";
import { useOnlineContext } from "helpers/contexts/OnlineContext/OnlineContext";

const useDataStoreSyncStatus = ({ restartDataStore }) => {
  const { isOnline: online } = useOnlineContext()

  const [isOutboxEmpty, setIsOutboxEmpty] = useState();
  const [outboxData, setOutboxData] = useState([]);
  const [isSyncingData, setIsSyncingData] = useState(online || true);
  const [imagesToUploadCount, setImagesToUploadCount] = useState(0);
  const [imagesToDownloadCount, setImagesToDownloadCount] = useState(0);

  useEffect(() => {
    const removeListenerDataStore = Hub.listen("datastore", onDataStoreEvent);

    checkImagesToUploadCount();
    checkImagesToDownloadCount();

    if (online) {
      window.isOnline = true
    }

    return () => {
      removeListenerDataStore();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (online) {
      dispatchEvent(new Event("online"));

      window.isOnline = true;
      
      try {
        getCurrentSession();
      } catch (e) {
        console.error("Datastore Auth issue", e);
      }

      restartDataStore();
    }

    if (!online) {
      dispatchEvent(new Event("offline"));
      
      setIsSyncingData(false)
      
      window.isOnline = false
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [online])

  async function checkImagesToUploadCount() {
    const outbox = new ImageOutbox();

    setImagesToUploadCount(await outbox.getPendingImageTotal());

    setTimeout(checkImagesToUploadCount, 1000);
  }

  async function checkImagesToDownloadCount() {
    const pendingDownloadCount = deviceImages.pendingDownloadCount

    setImagesToDownloadCount(pendingDownloadCount > -1 ? pendingDownloadCount : 0)

    if (pendingDownloadCount > 0) {
      setTimeout(checkImagesToDownloadCount, 1000);
    } else {
      setTimeout(checkImagesToDownloadCount, 3000);
    }
  }

  async function onDataStoreEvent(hubData) {
    const { event, data } = hubData.payload;
    // console.log(event, data)
    if (event === "networkStatus") {
      // setIsAmplifyOnline(data.active);
    } else if (event === "outboxStatus") {
      setIsOutboxEmpty(data.isEmpty);
      setOutboxData(data.idsInOutbox);
    } else if (event === "syncQueriesStarted") {
      setIsSyncingData(true);
    } else if (event === "syncQueriesReady") {
      setIsSyncingData(false);
    } else if (event === "outboxMutationDequeued") {
      await localDbSet(
        `dequeued-${data.element.id}`,
        JSON.stringify({ data, name: data.model })
      );
    } else if (event === "ready") {
      setIsSyncingData(false);
    }
  }

  return {
    isSyncingData,
    isOutboxEmpty,
    outboxData,
    imagesToUploadCount,
    imagesToDownloadCount,
  };
};

export default useDataStoreSyncStatus;
